"use strict";
import securtyTemplate from "./pages/securityTemplate";
import privacyTemplate from "./pages/privacyTemplate";
import termsAndConditionsTemplate from "./pages/termsAndConditionsTemplate";
import businessContinuityTemplate from "./pages/businessContinuityTemplate";
import brokerCheckTemplate from "./pages/brokerCheckTemplate";
import excessiveTradingTemplate from "./pages/excessiveTradingTemplate";

const DocsLinksService = function DocsLinksService() {
    return [
        {
            name: "security",
            text: "Requirements and Security",
            template: securtyTemplate,
            breadcrumb: "System Requirements and Security"
        },
        {
            name: "privacy",
            text: "Privacy",
            template: privacyTemplate,
            breadcrumb: "Privacy Notice"
        },
        {
            name: "terms-and-conditions",
            text: "Terms",
            template: termsAndConditionsTemplate,
            breadcrumb: "Terms and Conditions"
        },
        {
            name: "business-continuity",
            text: "Business Continuity",
            template: businessContinuityTemplate,
            breadcrumb: "Business Continuity Plan"
        },
        {
            name: "broker-check",
            text: "FINRA Investor Education",
            template: brokerCheckTemplate,
            breadcrumb: "FINRA Investor Education"
        },
        {
            name: "excessive-trading",
            text: "Market Timing and Excessive Trading",
            template: excessiveTradingTemplate,
            breadcrumb: "Market Timing and Excessive Trading Policies"
        }
    ];
};
export default DocsLinksService;
